import Queries from 'src/services/graphql/queries/index';
import { DashboardInput } from 'src/services/graphql/Models';
import Dashboard from './classes/Dashboard';
import DataStoreExtension from './generic/datastore';
import { DocumentNode } from 'graphql';
import authStore from '../authStore';

export class DashboardStore extends DataStoreExtension<DashboardInput, Dashboard> {
    listQueries: DocumentNode =  Queries.ListDashboards;
    _createQueries = () => authStore.isSuperUser ? Queries.CreateDashboard : undefined;
    _updateQueries = () => authStore.isSuperUser ? Queries.UpdateDashboard : undefined;
    _deleteQueries = () => authStore.isSuperUser ? Queries.DeleteDashboard : undefined;
    
    listVariables: any = () => ({
        input:  {
            clientId: authStore.clientId,
            typedId: 'db'
        }
    })

    constructor() {
        super(false);
    }

    toObject(from: DashboardInput): Dashboard {
        return new Dashboard(from);
    }

    countError(obj: DashboardInput) {
        let errors = [];
        const {
            name
        } = obj;

        if (!name || name.length < 2) {
            errors.push(new Error('SensorName is required'));
        }

        return errors;
    }

    parseDelete(obj: Dashboard) {
        return this.parseClientDelete(obj);
    }

}

export default new DashboardStore();


// WEBPACK FOOTER //
// ./src/stores/application/dashboard.ts